import React, { FC, Fragment, ReactNode, useState } from "react";
import ReactPlayer from "react-player";
import { useSelector } from "react-redux";
import { GetConfigData } from "store/config/selectors";
import { UploadType } from "store/url-builder";
import InsertDriveFileIcon from "@material-ui/icons/InsertDriveFile";
import { Box, CircularProgress } from "@material-ui/core";
import { ResourceType } from "enums/videoType";
import style from "./style.module.scss";

import ReactImage from "react-image-shimmer";

export interface FileReaderProps {
  file: UploadType;
  videoConfig?: {
    controls: boolean;
  };
}

let gcd: any = (a: number, b: number) => {
  return b ? gcd(b, a % b) : a;
};

let aspectRatio = (width: number, height: number) => {
  var divisor = gcd(width, height);
  return width / divisor + ":" + height / divisor;
};

export const FileReader: FC<FileReaderProps> = (props) => {
  const confData = useSelector(GetConfigData);
  const filePath =
    props.file.actionType === ResourceType.Regular
      ? confData.filesBaseUrl +
        confData.filesBasePath +
        "/" +
        props.file.fileName
      : props.file.fileUrl;

  const [bgImage, setBgImage] = useState<null | ReactNode>(null);

  if (props.file.mimeType.includes("image")) {
    if (filePath) {
      const img = new Image();
      img.src = filePath;
      img.onload = () => {
        if (aspectRatio(img.width, img.height) !== "1:1")
          setBgImage(<img src={img.src} alt="" className="slideBgImage" />);
      };
    }

    return (
      <Fragment>
        <ReactImage
          src={filePath || "https://"}
          fallback={
            <div className={style.loader}>
              <CircularProgress />
            </div>
          }
          nativeImgProps={{
            alt: props.file.fileName,
            width: "100%",
            height: "auto",
            style: {
              objectFit: "contain",
            },
          }}
        />
        {props.videoConfig?.controls && bgImage}
      </Fragment>
    );
  }

  if (
    props.file.mimeType.includes("video") ||
    (!props.file.mimeType.includes("image") &&
      ![
        "png",
        "jpg",
        "jpeg",
        "pdf",
        "svg",
        "gif",
        "ai",
        "eps",
        "raw",
        "indd",
        "tiff",
      ].includes(
        props.file?.fileUrl?.slice(
          props.file?.fileUrl!.lastIndexOf(".") + 1,
          props.file?.fileUrl?.length
        ) || ""
      ))
  )
    return (
      <div
        className={style.playerWrapper}
        style={{ pointerEvents: props.videoConfig?.controls ? "all" : "none" }}
      >
        <ReactPlayer
          url={filePath}
          width="100%"
          height="auto"
          {...props.videoConfig}
        />
      </div>
    );

  return (
    <Box
      sx={{
        width: "100%",
        height: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Box sx={{ textAlign: "center" }}>
        <InsertDriveFileIcon fontSize="large" />
        <div>
          <small>{props.file.mimeType}</small>
        </div>
      </Box>
    </Box>
  );
};
